<template>
  <s-btn v-if="loggedInUser?.isSuperUser" color="danger-white" icon="cog" :href :size="size">
    {{ $t('admin') }}
  </s-btn>
</template>
<script setup lang="ts">
import SBtn from '../design-system/SBtn.vue';
import {usePage} from '@inertiajs/vue3';

defineProps<{
  href: string;
  size?: 'sm' | 'md' | 'lg';
}>();

const loggedInUser = usePage().props.loggedInUser;
</script>
